<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding10" :style="{ 'min-height': `${this.screenHeight - 160}px` }">
        <el-row>
            <el-col :span="16" class="align-left">
                <h3>
                    第{{ h_t || '--' }}次交班
                    <!-- <el-tag type="danger" size="mini" effect="light" v-if="activeHandover&&activeHandover.unsaved">尚未保存</el-tag> -->
                </h3>
            </el-col>
            <el-col :span="8">
                <el-row type="flex" justify="end">
                    <el-col :span="16" v-if="activeHandover && activeHandover.unsaved" class="align-right">
                        <el-button type="warning" size="mini" @click="SaveChanges"><i class="el-icon-loading" v-if="!finished"></i>保存</el-button>
                        &nbsp;
                        <el-link type="warning" size="mini" @click="clearChanges">撤销修改</el-link>
                    </el-col>
                    <el-col :span="8">
                        <el-button type="primary" size="mini" @click="addNewHandover()">创建交接</el-button>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <br />
        <el-row>
            <el-col :span="24" class="align-left">
                <label style="line-height: 35px">时间:</label>
                <item-input
                    style="width: 150px"
                    :collapseTags="true"
                    :noPadding="true"
                    datetimeFormate="yyyy/MM/dd HH:mm"
                    type="datetime"
                    v-model="shift_time"
                    placeholder="交班时间"
                    @input="changed"
                ></item-input>
                <label style="line-height: 35px">{{ T(`handover_nurse.fact_equipment_nurse`) }}:</label>
                <item-input
                    class="block-multi-collapse-select-width"
                    :collapseTags="true"
                    :multipleLimit="2"
                    type="remotemultiselect"
                    v-model="equipment_nurse_old"
                    :options="workoption"
                    placeholder="交班人"
                    @input="changed"
                ></item-input>
                <span class="el-icon-right"></span>
                <item-input
                    class="block-multi-collapse-select-width"
                    :collapseTags="true"
                    :multipleLimit="2"
                    type="remotemultiselect"
                    v-model="equipment_nurse_new"
                    :options="workoption"
                    placeholder="接班人"
                    @input="changed"
                ></item-input>
                <label style="line-height: 35px">巡回:</label>
                <item-input
                    class="block-multi-collapse-select-width"
                    :collapseTags="true"
                    :multipleLimit="2"
                    type="remotemultiselect"
                    v-model="circuit_nurse_old"
                    :options="workoption"
                    placeholder="交班人"
                    @input="changed"
                ></item-input>
                <span class="el-icon-right"></span>
                <item-input
                    class="block-multi-collapse-select-width"
                    :collapseTags="true"
                    :multipleLimit="2"
                    type="remotemultiselect"
                    v-model="circuit_nurse_new"
                    :options="workoption"
                    placeholder="接班人"
                    @input="changed"
                ></item-input>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="18" :md="16">
                <DocFrame ref="doc" :docno="this.$root.DOCUMENT.SZJJ013" :guid="docguid" :surgeryId="surgeryId" docname="术中交接" @saved="afterDocSaved" @changed="changed"></DocFrame>
            </el-col>
            <el-col :lg="6" :md="8">
                <div v-if="handovers.length == 0">&nbsp;</div>
                <el-row v-else class="margin20 margin-none-h">
                    <!-- <h3 class="align-center">交接记录</h3> -->
                    <el-timeline class="align-left handover-nurse">
                        <el-timeline-item placement="top" type="info" :timestamp="surgeryBegin"> 手术开始 </el-timeline-item>
                        <el-timeline-item
                            placement="top"
                            v-for="(activity, index) in savedHandovers"
                            :type="active === activity.document_id ? 'primary' : 'info'"
                            :key="index"
                            :timestamp="activity.shift_time"
                        >
                            <el-card>
                                <div>{{ trans }}：{{ activity.equipment_nurse_old }}<span class="el-icon-right"></span>{{ activity.equipment_nurse_new }}</div>
                                <div>巡回：{{ activity.circuit_nurse_old }}<span class="el-icon-right"></span>{{ activity.circuit_nurse_new }}</div>
                                <div class="align-right padding5" v-if="activity.id > 0">
                                    <el-link type="info" @click="activeNode(activity)"><span class="el-icon-edit"></span>编辑</el-link>
                                    <el-link type="danger" @click="deleteHandover(activity)"><span class="el-icon-delete"></span>删除</el-link>
                                </div>
                                <div class="align-right padding5" v-else>
                                    <el-tag type="danger" size="mini" effect="light" v-if="activeHandover && activeHandover.unsaved">尚未保存</el-tag>
                                </div>
                            </el-card>
                        </el-timeline-item>
                        <!-- 手术结束显示手术结束标记，未结束则显示下一次交班 -->
                        <el-timeline-item placement="top" type="info" :timestamp="surgeryEnd" v-if="surgeryEnd"> 手术结束 </el-timeline-item>
                    </el-timeline>
                </el-row>
            </el-col>
        </el-row>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `HandoverNurse`,
    props: {},
    data() {
        return {
            title: `护士交班`,
            surgeryId: this.$route.query.surgery_id,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            surgeryInfo: undefined,
            handovers: [],
            shift_time: this.$moment(new Date()).format(`YYYY/MM/DD HH:mm:ss`),
            equipment_nurse_old: [],
            equipment_nurse_new: [],
            circuit_nurse_old: [],
            circuit_nurse_new: [],
            active: ``,
            xh: [],
            qx: [],
            finished: true,
            h_t: 1,
            trans: this.T(`handover_nurse.fact_equipment_nurse`)
        }
    },
    mounted() {
        this.loadSurgery()
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadHandovers()
        // this.$refs.doc.loadDocument()
    },
    computed: {
        ...mapGetters([`sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `currentUser`, `screenHeight`]),
        docguid() {
            return `${this.active}`
        },
        savedHandovers() {
            return _.filter(this.handovers, { unsaved: false })
        },
        activeHandover() {
            let index = _.findIndex(this.handovers, { document_id: this.active })
            this.h_t = index + 1
            return this.handovers[index]
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        surgeryBegin() {
            return (this.surgeryInfo && this.surgeryInfo.in_room && this.$moment(this.surgeryInfo.in_room).format(`YYYY/MM/DD HH:mm:ss`)) || `--`
        },
        surgeryEnd() {
            return (this.surgeryInfo && this.surgeryInfo.enum_surgery_status >= 40 && this.$moment(this.surgeryInfo.out_room).format(`YYYY/MM/DD HH:mm:ss`)) || `--`
        },
        workoption() {
            return q => {
                let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                if (q && q.keyword) {
                    return works.filter(d => {
                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                    })
                } else {
                    return works
                }
            }
        }
    },
    methods: {
        loadSurgery() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
            req.then(data => {
                this.surgeryInfo = data
                // console.log(this.surgeryInfo)
            }).catch(e => console.log(e))
        },
        loadHandovers() {
            if (!this.surgeryId) return
            let req1 = this.myaxios.get(`/api/Nursing/ShiftWorker/Get?surgeryId=${this.surgeryId}&shiftType=2`)
            let req2 = this.myaxios.get(`/api/Nursing/ShiftWorker/GetDefault?surgeryId=${this.surgeryId}&workerDuty=5`) // 巡回护士
            let req3 = this.myaxios.get(`/api/Nursing/ShiftWorker/GetDefault?surgeryId=${this.surgeryId}&workerDuty=6`) // 器械护士
            this.myaxios
                .all(req1, req2, req3)
                .then(([hs, xh, qx]) => {
                    // this.xh = xh
                    // this.qx = qx
                    this.handovers = _.filter(hs, `id`).map(h => {
                        return {
                            // content:"手术开始",
                            shift_time: this.$moment(h.shift_time || h.modify_date).format(`YYYY/MM/DD HH:mm:ss`),
                            circuit_nurse_old_v: h.circuit_nurse_old,
                            circuit_nurse_old: h.circuit_nurse_old.map(c => c.label).toString(),
                            circuit_nurse_new_v: h.circuit_nurse_new,
                            circuit_nurse_new: h.circuit_nurse_new.map(c => c.label).toString(),
                            equipment_nurse_old_v: h.equipment_nurse_old,
                            equipment_nurse_old: h.equipment_nurse_old.map(c => c.label).toString(),
                            equipment_nurse_new_v: h.equipment_nurse_new,
                            equipment_nurse_new: h.equipment_nurse_new.map(c => c.label).toString(),
                            document_id: h.document_id,
                            unsaved: false,
                            id: h.id
                        }
                    })
                    if (this.handovers.length == 0) {
                        this.addNewHandover()
                    } else {
                        this.activeNode(_.last(this.handovers))
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        afterDocSaved() {
            this.saveHandOver()
        },
        saveHandOver() {
            let h = this.activeHandover
            if (!this.saving) {
                this.saving = true
                let req
                if (h.id > 0) {
                    req = this.myaxios.put(`/api/Nursing/ShiftWorker/Put`, {
                        equipment_nurse_old: this.equipment_nurse_old.map(d => d.value),
                        equipment_nurse_new: this.equipment_nurse_new.map(d => d.value),
                        circuit_nurse_old: this.circuit_nurse_old.map(d => d.value),
                        circuit_nurse_new: this.circuit_nurse_new.map(d => d.value),
                        surgery_id: this.surgeryId,
                        document_id: h.document_id,
                        shift_time: this.shift_time,
                        modify_date: this.shift_time,
                        other_text: h.order,
                        enum_shift_type: 2,
                        id: h.id
                    })
                } else {
                    req = this.myaxios.post(`/api/Nursing/ShiftWorker/Post`, {
                        equipment_nurse_old: this.equipment_nurse_old.map(d => d.value),
                        equipment_nurse_new: this.equipment_nurse_new.map(d => d.value),
                        circuit_nurse_old: this.circuit_nurse_old.map(d => d.value),
                        circuit_nurse_new: this.circuit_nurse_new.map(d => d.value),
                        surgery_id: this.surgeryId,
                        document_id: h.document_id,
                        shift_time: this.shift_time,
                        modify_date: this.shift_time,
                        other_text: h.order,
                        enum_shift_type: 2,
                        id: h.id
                    })
                }

                req.then(data => {
                    this.finished = true
                    this.saving = false
                    this.loadHandovers()
                }).catch(e => {
                    this.finished = true
                    this.saving = false
                    console.log(e)
                })
            }
        },
        activeNode(activity) {
            if (this.activeHandover && this.activeHandover.unsaved && this.activeHandover.id !== activity.id && this.activeHandover.id > 0) {
                this.$message.warning(`尚存在未保存的交接，不允许编辑其它交接记录`)
                return
            }
            this.active = activity.document_id
            this.shift_time = activity.shift_time
            this.circuit_nurse_old = activity.circuit_nurse_old_v || []
            this.circuit_nurse_new = activity.circuit_nurse_new_v || []
            this.equipment_nurse_old = activity.equipment_nurse_old_v || []
            this.equipment_nurse_new = activity.equipment_nurse_new_v || []
            this.$refs.doc.loadDocument()
        },
        addNewHandover() {
            let req1 = this.myaxios.get(`/api/Nursing/ShiftWorker/GetDefault?surgeryId=${this.surgeryId}&workerDuty=5`) // 巡回护士
            let req2 = this.myaxios.get(`/api/Nursing/ShiftWorker/GetDefault?surgeryId=${this.surgeryId}&workerDuty=6`) // 器械护士
            this.myaxios.all(req1, req2).then(([data, data1]) => {
                this.xh = data
                this.qx = data1
                let newHandover = {
                    // content:"手术开始",
                    shift_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    circuit_nurse_old_v: this.xh && this.xh,
                    circuit_nurse_old: (this.xh && this.xh.map(d => d.label)) || [],
                    circuit_nurse_new_v: [],
                    circuit_nurse_new: ``,
                    equipment_nurse_old_v: this.qx && this.qx,
                    equipment_nurse_old: (this.qx && this.qx.map(d => d.label)) || [],
                    equipment_nurse_new_v: [],
                    equipment_nurse_new: ``,
                    document_id: `handover_${this.surgeryId}_${this.generateUUID()}`,
                    id: 0,
                    unsaved: true
                }
                if (this.handovers.length > 0) {
                    let lastHandover = _.last(this.handovers)
                    if (lastHandover.unsaved) {
                        this.$message.warning(`尚未保存上一次交接，不允许新增交接记录`)
                        return
                    }
                    Object.assign(newHandover, {
                        circuit_nurse_old_v: lastHandover.circuit_nurse_new_v || [],
                        circuit_nurse_old: lastHandover.circuit_nurse_new || [],
                        equipment_nurse_old_v: lastHandover.equipment_nurse_new_v || [],
                        equipment_nurse_old: lastHandover.equipment_nurse_new || []
                    })
                }

                this.handovers.push(newHandover)
                this.activeNode(newHandover)
            })
        },
        deleteHandover() {
            let handoverIndex = _.findIndex(this.handovers, { document_id: this.active })
            if (this.handovers[handoverIndex].id == 0) return
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/Nursing/ShiftWorker/DeleteById?headId=${this.handovers[handoverIndex].id}`)
                req.then(data => {
                    this.handovers.splice(handoverIndex, 1)
                    if (this.handovers.length > 0) {
                        this.activeNode(_.last(this.handovers))
                    } else {
                        this.addNewHandover()
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        generateUUID() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            return uuid
        },
        clearChanges() {
            if (this.activeHandover.id > 0) {
                this.$set(this.activeHandover, `unsaved`, false)
                this.activeNode(this.activeHandover)
            } else if (this.savedHandovers.length > 0) {
                this.handovers = this.savedHandovers
                this.activeNode(_.last(this.savedHandovers))
            } else {
                this.activeNode(this.activeHandover)
            }
            this.finished = true
        },
        SaveChanges() {
            //  保存用户更改，成功刷新数据，失败不刷新
            let that = this
            let valid = true

            let equipmentNurseOldObj = this.equipment_nurse_old.map(d => d.value)
            let equipmentNurseNewObj = this.equipment_nurse_new.map(d => d.value)
            let circuitNurseOldObj = this.circuit_nurse_old.map(d => d.value)
            let circuitNurseNewObj = this.circuit_nurse_new.map(d => d.value)

            if (this.shift_time.length == 0) {
                valid = false
                this.$message.error(`交班时间不能为空`)
            } else if ((equipmentNurseOldObj.length == 0 || equipmentNurseNewObj.length == 0) && (circuitNurseOldObj.length == 0 || circuitNurseNewObj.length == 0)) {
                valid = false
                this.$message.error(`交班护士不能全部为空`)
            } else if (
                (equipmentNurseNewObj.toString() == equipmentNurseOldObj.toString() && equipmentNurseNewObj.length + equipmentNurseOldObj.length > 0) ||
                (circuitNurseNewObj.toString() == circuitNurseOldObj.toString() && circuitNurseNewObj.length + circuitNurseOldObj.length > 0)
            ) {
                valid = false
                this.$message.error(`交班护士与接班护士不能是同一个人`)
            }
            if (that.finished && valid) {
                that.finished = false
                this.$refs.doc.save()
            }
        },
        changed() {
            this.$set(this.activeHandover, `unsaved`, true)
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadHandovers()
            this.loadSurgery()
        }
    }
}
</script>
<style scoped>
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
h3 {
    margin: 0;
}
</style>
<style  lang="less">
.handover-nurse .el-timeline-item__node {
    cursor: pointer;
    z-index: 2;
    &:hover {
        width: 20px;
        height: 20px;
        left: -6px;
        top: -6px;
        background: #409eff;
    }
}
.is-md-and-down .block-multi-collapse-select-width {
    width: 115px !important;
}
.block-multi-collapse-select-width {
    width: 135px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/HandoverNurse/Index.vue